/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Visitors_SourceInputs */

const en_directory_rails_visitors_source = /** @type {(inputs: Directory_Rails_Visitors_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measured by Cloudflare`)
};

const zh_directory_rails_visitors_source = /** @type {(inputs: Directory_Rails_Visitors_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据来自 Cloudflare`)
};

/**
* | output |
* | --- |
* | "Measured by Cloudflare" |
*
* @param {Directory_Rails_Visitors_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_visitors_source = /** @type {((inputs?: Directory_Rails_Visitors_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Visitors_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_visitors_source(inputs)
	return zh_directory_rails_visitors_source(inputs)
});
export { directory_rails_visitors_source as "directory.rails.visitors_source" }